"use client";
import React from "react";
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';

const ContactInfoSection = () => {
  const infos = [
    {
      id: 1,
      label: "Adresse",
      icon: <FiMapPin className="w-5 h-5" />,
      text: "54 rue du mercure, Ben Arous",
      link: null
    },
    {
      id: 2,
      label: "Téléphone",
      icon: <FiPhone className="w-5 h-5" />,
      text: "+216 98 148 481",
      link: "tel:+21698148481"
    },
    {
      id: 3,
      label: "Email",
      icon: <FiMail className="w-5 h-5" />,
      text: "contact@parex.tn",
      link: "mailto:contact@parex.tn"
    },
  ];

  return (
    <section className="py-12 bg-gray-50">
      <div className="container max-w-7xl mx-auto px-4">
        {/* Container: Scrollable sur mobile, Grid sur desktop */}
        <div className="flex md:grid md:grid-cols-3 gap-5 overflow-x-auto pb-6 md:pb-0 snap-x snap-mandatory scrollbar-hide">
          {infos.map((info) => (
            <div
              key={info.id}
              onClick={() => info.link && (window.location.href = info.link)}
              className={`
                flex-shrink-0 w-[85%] md:w-full snap-center
                flex items-start space-x-4 p-6 
                bg-white border border-gray-100 rounded-2xl
                transition-all duration-300 group
                ${info.link ? "cursor-pointer hover:bg-white hover:hover:shadow-gray-200/50 hover:-translate-y-1" : ""}
              `}
            >
              {/* Icon Circle */}
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-full bg-gray-50 text-main group-hover:bg-gray-50 group-hover:text-white transition-colors duration-300">
                {info.icon}
              </div>

              {/* Text Content */}
              <div className="flex flex-col">
                <span className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-1">
                  {info.label}
                </span>
                <span className="text-sm text-main font-bold leading-tight">
                  {info.text}
                </span>
                {info.link && (
                  <span className="text-[10px] text-blue-600 mt-2 font-bold opacity-0 group-hover:opacity-100 transition-opacity">
                    Cliquez pour contacter →
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Indicateur visuel pour mobile (petits points) */}
        <div className="flex justify-center space-x-2 mt-4 md:hidden">
          {infos.map((_, i) => (
            <div key={i} className={`h-1.5 rounded-full ${i === 0 ? 'w-6 bg-gray-50' : 'w-2 bg-gray-200'}`} />
          ))}
        </div>
      </div>

      <style jsx global>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>
  );
};

export default ContactInfoSection;